<template>
  <div
    class="project-footer"
    v-if="parent.selectedProject!==null && parent.currentProjectView!==null"
  >
    <div class="project-footer-wrapper intro" v-if="parent.currentProjectView!==null&&showFooter">
      <div class="project-nav-container">
        <ProjectNav :projects="getFilteredProjects()" :parent="parent" :footer="true"/>
      </div>
      <div id="project-footer-container" class :style="{'--color':selectedProject.bgColor}">
        <div
          class="project-image-container"
          v-for="( project, index) in getFilteredProjects()"
          :key="index"
          :class="{'active':selectedProject.id===project.id}
            "
        >
          <div
            class="project"
            v-lazy:background-image="parent.getImageUrl(project.cover)"
            :key="parent.getImageUrl(project.cover)"
          >
            <div class="project-view-title animated">
              <span class="project-name animated">{{project.name}}</span>
              <span class="project-category animated">{{project.category}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectNav from "../components/project-nav.vue";
import animateScrollTo from "animated-scroll-to";

export default {
  name: "project-footer",
  components: {
    ProjectNav
  },
  props: ["parent"],
  mounted() {
    this.$eventBus.$on("showFooter", this.handleShowFooterEvent);
    this.$eventBus.$on("updateProject", this.updateProject);
    this.$eventBus.$on("updateFooterView", this.updateFooterView);
  },
  data() {
    return {
      selectedProject: null,
      enableHover: true,
      showFooter: false,
      timer: null
    };
  },
  methods: {
    updateProject(p) {
      if (this.enableHover) this.selectedProject = p;
    },
    updateFooterView(p) {
      if (this.enableHover) this.animateInProjectView(p);
    },
    handleShowFooterEvent() {
      this.selectedProject = this.getFilteredProjects()[0];
      this.showFooter = true;
      this.delayTime(500).then(() => this.openingPageAnimation());
      this.$eventBus.$off("showFooter", this.handleShowFooterEvent);
    },
    getFilteredProjects() {
      const self = this;
      return self.parent.currentProjectView
        ? this.parent.projects.filter(p => {
            return p.id !== self.parent.currentProjectView.id;
          })
        : [];
    },
    delayTime(t, ele) {
      return new Promise(resolve => {
        if (this.timer !== null) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          resolve(ele);
        }, t);
      });
    },
    async openingPageAnimation() {
      this.enableHover = false;
      const eles = this.getAnimateElements();
      const allNavs = document.querySelectorAll(".project-footer .nav-item");

      await this.delayTime(400).then(
        eles.projectContainer.classList.add("open-backdrop")
      );

      eles.projectContainer.scrollIntoView({
        behavior: "smooth",
        block: "end"
      });

      document
        .querySelector(".project-footer-wrapper")
        .classList.remove("intro");

      allNavs.forEach(nav => nav.classList.remove("fadeInLeft"));
      eles.navs.style.display = "block";

      await this.delayTime(100).then(() =>
        eles.coverMask.classList.add("active")
      );

      const loop = async array => {
        let index = 0;

        while (index < array.length) {
          await this.delayTime(100).then(() => {
            array[index].classList.add("fadeInLeft");
          });
          index++;
        }
      };
      await this.delayTime(1000).then(() => loop(allNavs));
      this.enableHover = true;
    },
    async animateInProjectView(p) {
      this.enableHover = false;
      const eles = this.getAnimateElements();

      window.scrollTo(0, eles.footer.offsetTop);

      document.querySelector("body").style.overflowY = "scroll";
      eles.coverMask.classList.add("view");
      eles.footer.querySelector(".copyright").classList.add("fadeOut");
      await this.delayTime(1600).then(() => {
        eles.footer.querySelector(".project-footer-wrapper").style.height =
          document.body.clientHeight + "px";
        eles.projectGallery.style.marginBottom = "0";
      });

      await this.delayTime(1200).then(() =>
        eles.projectName.classList.add("fadeInUp")
      );

      await this.delayTime(300).then(() =>
        eles.projectCategory.classList.add("fadeInUp")
      );
      eles.projectGallery.style.display = "none";
      this.$eventBus.$emit("showFixedHeader");
      this.parent.selectedProject = p;
      await this.delayTime(1000).then(() => {
        this.parent.currentProjectView = null;
        this.$nextTick(() => {
          this.parent.currentProjectView = p;
          this.enableHover = true;
          window.scrollTo(0, 0);
          this.parent.disableScroll();
          eles.projectGallery.style.display = "";
        });
      });

      //reset
      await this.delayTime(200).then(() => {
        eles.footer.style.display = "";
        this.delayTime(200).then(() => {
          this.showFooter = false;
          this.$eventBus.$on("showFooter", this.handleShowFooterEvent);
          this.parent.enableScroll();
        });
      });
    },
    getAnimateElements() {
      const coverMask = document.querySelector(
        ".project-footer .project-image-container.active"
      );
      return {
        footer: document.querySelector(".project-footer"),
        projectGallery: document.getElementById("project-gallery"),
        projectContainer: document.getElementById("project-footer-container"),
        navs: document.querySelector(".project-footer .project-nav"),
        activeCover: coverMask.querySelector(".project"),
        coverMask: coverMask,
        projectName: coverMask.querySelector(".project-name"),
        projectCategory: coverMask.querySelector(".project-category")
      };
    }
  },
  beforeDestroy() {
    if (this.timer !== null) {
      clearTimeout(this.timer);
    }
    this.$eventBus.$off("showFooter", this.handleShowFooterEvent);

    this.$eventBus.$off("updateProject", this.updateProject);

    this.$eventBus.$off("updateFooterView", this.updateFooterView);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.project-footer {
  border-top: #999 solid 1px;
  margin-top: 75px;
  width: 100%;
  height: 500px;
  transition: height 0.6s cubic-bezier(0.8, 0.03, 0.25, 1);
  opacity: 1;
  background-color: #fff;
  position: relative;
}
.project-footer-wrapper {
  position: absolute;
  bottom: 0;
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #fff;
  transition: all 0.6s cubic-bezier(0.8, 0.03, 0.25, 1);
}
#project-footer-container:before {
  content: "";
  transform: scaleY(0);
  background-color: var(--color);
  width: 100%;
  height: 100%;
  display: block;
  transform-origin: top;
  /* transition: background-color 0.6s ease-in-out; */
  transition: all 0.6s cubic-bezier(0.8, 0.03, 0.25, 1);
  z-index: 0;
  position: absolute;
  top: 0;
  right: 0;
}

.project-nav-container {
  width: 100%;
}

#project-footer-container {
  width: 100%;
  height: 100%;
  position: relative;
}
.project {
  position: absolute;
  width: 80vw;
  height: 100%;
  top: 0;
  right: 0;
  background-position: right;
  background-repeat: no-repeat;
  background-size: cover;
  transition: 0.6s all ease-in-out;
  transition-delay: 0.6s;
}
.footer-scroll-hint {
  position: absolute;
  bottom: 1rem;
  left: 6%;
  font-size: 0.75rem;
  color: #949494;
  animation-duration: 2s;
  opacity: 0;
  transition: 0.5s opacity ease-in-out 2s;
}
.show {
  opacity: 1;
}

.project-image-container {
  right: 0;
  position: absolute;
  overflow: hidden;
  width: 0;
  height: calc(100% - 80px);
  transition: width 0.6s cubic-bezier(0.8, 0.03, 0.25, 1),
    -webkit-width 0.6s cubic-bezier(0.8, 0.03, 0.25, 1);
}
.project-image-container.view .project {
  width: 100vw;
}

.project-view-title {
  position: absolute;
  color: white;
  top: 50%;
  left: 10%;
  display: flex;
  flex-direction: column;
  animation-duration: 0.5s;
  /* animation-delay:1s; */
  opacity: 1;
  width: 100%;
}
.project-view-title:before {
  content: "";
  position: absolute;
  width: 30px;
  height: 3px;
  top: -2rem;
  background-color: #fff;
}
.project-view-title .project-name {
  font-size: 3rem;
  /* line-height: 1.5rem; */
  font-weight: bold;
  opacity: 0;
  animation-duration: 0.3s;
  /* animation-delay: 1.5s; */
}
.project-view-title .project-category {
  font-size: 1.5rem;
  animation-duration: 0.3s;
  /* animation-delay: 1.8s; */
  text-transform: uppercase;
  opacity: 0;
}
.intro .project-image-container.active {
  width: 0 !important;
}

.intro .project-image-container.active {
  width: 0 !important;
}

.close {
  width: 0%;
}
.active {
  opacity: 1;
  transition-delay: 0.6s;
  background-size: cover;
  width: calc(100% + 80px);
  z-index: 99;
}

.view {
  width: 200% !important;
}

.full-height-footer {
  /* position: fixed;
  bottom: 0;
  height: 100%;
  z-index: 9999; */
  height: 100%;
  bottom: -500px;
  transition: all 1s cubic-bezier(0.6, 0.03, 0.25, 1);
}
.fixed-footer {
  position: fixed;
  bottom: 0;
}
#project-footer-container.open-backdrop:before {
  transform: scaleY(1);
  animation: tranformY-animation 0.6s cubic-bezier(0.6, 0.03, 0.25, 1); /* transform: translateY(0%); */
}

@keyframes tranformYOut-animation {
  0% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(-100%);
  }
}

@keyframes tranformY-animation {
  0% {
    transform: scaleY(0);
  }
  100% {
    transform: scaleY(1);
  }
}

.no-transition {
  transition: none !important;
  animation-delay: 0;
  transition-delay: 0;
}
</style>
